export default __webpack_public_path__ + "static/media/5de2625ab4b90fb1868f1c33edfb88e6.51bde2b0.gif";